import { createSlice } from "@reduxjs/toolkit";

export const bankerAuthSlice = createSlice({
  name: "bankerAuth",
  initialState: {
    user: null,
    accessToken: null,
    bank: null,
    currentBranch: null,
    redirectUrl: null
  },

  reducers: {
    setBankerUser: (state, action) => {
      state.user = action.payload;
    },

    setBankerTokens: (state, action) => {
      state.accessToken = action.payload.access_token;
    },

    setBank: (state, action) => {
      state.bank = action.payload;
    },

    setCurrentBranch: (state, action) => {
      state.currentBranch = action.payload;
    },

    setBankerRedirectUrl: (state, action) => {
      state.redirectUrl = action.payload;
    },

    clearBankerRedirectUrl: (state) => {
      state.redirectUrl = null;
    },

    clearBankerAuth: (state) => {
      state.user = null;
      state.accessToken = null;
      state.currentBranch = null;
      state.redirectUrl = null;
    },
  },
});

export const { setBankerUser, setBankerTokens, clearBankerAuth, setBank, setCurrentBranch, setBankerRedirectUrl, clearBankerRedirectUrl } =
  bankerAuthSlice.actions;

export default bankerAuthSlice.reducer;
